import moment from "moment";
import { AvisConstants } from "../../../../../../data/avisConstants";
import {
  IAvisEditableListFieldConfig,
  IEditableListRowState,
  IEditableRowState,
} from "../../types";

interface IAvisFieldValueViewProps<P extends IEditableListRowState> {
  value: any;
  rowValue: P;
  rowState?: IEditableRowState;
  field: IAvisEditableListFieldConfig<P>;
}
export function AvisFieldValueView<P extends IEditableListRowState>(
  props: Readonly<IAvisFieldValueViewProps<P>>,
) {
  const { value, rowValue, field } = props;

  let valueFormatted = field.transformViewValue
    ? field.transformViewValue(value, rowValue)
    : value;
  switch (field.dataType) {
    case "Date": {
      if (!value) break;

      valueFormatted = moment(value).format(AvisConstants.date_format);
      break;
    }
    case "Double": {
      if (valueFormatted == 0) {
        valueFormatted = "";
        break;
      }
      if (!valueFormatted) break;

      if (valueFormatted?.toFixed) valueFormatted = valueFormatted.toFixed(2);

      valueFormatted = valueFormatted.toString().replace(/[.,]/g, ",");
      break;
    }
  }

  return <>{valueFormatted}</>;
}
